module.exports = __webpack_public_path__ + "static/media/2.49e6b4d6.jpeg";